import React, { useState } from 'react';
import { Button, Form, Modal, Col, Row } from 'react-bootstrap';
import { apiFetch } from '../services/apiService';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const ModalEditNews = ({ novinka, fetchAllNews }) => {
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState(novinka.title);
    const [content, setContent] = useState(novinka.content);
    const [eventType, setEventType] = useState(novinka.typeEvent);
    const [important, setImportant] = useState(novinka.important);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Funkce pro smazání novinky
    const deleteNews = async (id) => {
        try {
            await apiFetch(`/api/news/deleteNews/${id}`, { method: 'DELETE' });
            fetchAllNews(); // Znovu načíst novinky po smazání
        } catch (error) {
            console.error('Chyba při mazání novinky:', error);
        }
    };

    const handleSubmit = async () => {
        try {
            await apiFetch(`/api/news/editNews/${novinka._id}`, {
                method: 'PUT',
                body: JSON.stringify({ title, content, eventType, important }),
            });
            handleClose();
            await fetchAllNews(); // Aktualizovat seznam novinek
        } catch (error) {
            console.error('Chyba při pokusu editovat novinku:', error);
        }
    };

    return (
        <div>
            <Button variant="outline-dark" size='sm' onClick={handleShow} className='ms-3'>
                Editovat
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Editovat Novinku</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="title">
                                <Form.Label>Nadpis</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Nadpis novinky"
                                    value={title}
                                    onChange={e => setTitle(e.target.value)}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="content">
                                <Form.Label>Obsah</Form.Label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={content}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setContent(data); // Aktualizace stavu s daty editoru
                                    }}
                                />
                            </Form.Group>
                        </Row>

                        <Form.Group className="mb-3" controlId="formGridState">
                            <Form.Label>Typ události</Form.Label>
                            <Form.Select
                                defaultValue={eventType} // Předpokládá se, že "0" je výchozí hodnota pro "Informace"
                                onChange={e => setEventType(Number(e.target.value))} // Převod hodnoty na číslo
                            >
                                <option value="0">Informace</option>
                                <option value="1">Speciální akce</option>
                                <option value="2">Zavřeno</option>
                            </Form.Select>
                        </Form.Group>


                        <Form.Group className="mb-3" id="important">
                            <Form.Check
                                type="checkbox"
                                label="Akutní"
                                checked={important}
                                onChange={e => setImportant(e.target.checked)} />
                        </Form.Group>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        onClick={() => deleteNews(novinka._id)}
                        className='me-auto'
                        style={{ margin: '5px' }}
                    >Smazat</Button>

                    <Button variant="outline-secondary" onClick={handleClose}>Zrušit editaci</Button>
                    <Button variant="outline-info" onClick={handleSubmit}>Uložit změny</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ModalEditNews;
